// src/components/KhoanCoDinh.js
import React, { useState } from "react";
import { addData, updateData, deleteData } from "../services/api";
import { hoiXoa } from "../vo";

// ============================================================
// 📋 KHOẢN CHI CỐ ĐỊNH — chủ nhà soạn (Đợt N8, 15/09/2026)
// ------------------------------------------------------------
// Anh 08/09: *"tháng này liệu gia chủ có bị bỏ sót không?"* Anh chốt CN3 15/09:
// nhắc ở ⚙️ Việc của chủ nhà + số đỏ (máy chủ đưa vào từ ngày 20).
//
// Ở đây: danh mục (tên + kỳ) · tháng này còn thiếu khoản nào · nút "Tháng này
// không có" để tắt nhắc riêng tháng đó (tháng đó thật sự không phát sinh).
// ⚠️ So TÊN, không so tiền — không phải kế toán (4.3).
// ============================================================

const TEN_KY = { thang: "hằng tháng", quy: "hằng quý", nam: "hằng năm" };

const veKy = (k) => (k.ky === "thang" ? TEN_KY.thang : `${TEN_KY[k.ky]} · từ tháng ${k.thang_den}`);

const FORM_TRONG = { ten: "", ky: "thang", thang_den: 1 };

function KhoanCoDinh({ tt, onDoi, noiBao }) {
  const [form, setForm] = useState(FORM_TRONG);
  const [dangLam, setDangLam] = useState(false);

  if (tt === null) return <div className="card" id="khoan-co-dinh"><h3>📋 Khoản chi cố định</h3><p className="kho-anh-ghi">⏳ Đang tải…</p></div>;
  if (tt === "loi") {
    return (
      <div className="card" id="khoan-co-dinh">
        <h3>📋 Khoản chi cố định</h3>
        <p className="kho-anh-ghi sao-luu-loi">⚠️ Không tải được. Bấm F5 thử lại.</p>
      </div>
    );
  }

  const thieu = new Set(tt.thieu.map((k) => k.id));

  const lam = async (viec, thanhCong) => {
    setDangLam(true);
    try {
      await viec();
      if (thanhCong) noiBao(thanhCong);
      onDoi();
    } catch (err) {
      noiBao(`⚠️ Chưa được${err.chiTiet ? ` — ${err.chiTiet}` : ""}`);
    } finally {
      setDangLam(false);
    }
  };

  const them = (e) => {
    e.preventDefault();
    if (!form.ten.trim()) return noiBao("⚠️ Chưa có tên khoản");
    lam(async () => {
      await addData("quan-tri/khoan-co-dinh", form);
      setForm(FORM_TRONG);
    }, `✅ Đã thêm "${form.ten.trim()}"`);
  };

  return (
    <div className="card" id="khoan-co-dinh">
      <h3>📋 Khoản chi cố định</h3>
      <p className="kho-anh-ghi" style={{ marginTop: -4 }}>
        Những khoản tháng nào (quý nào, năm nào) cũng có. Từ ngày {tt.nhac_tu_ngay} hằng tháng, khoản đến kỳ mà bản tin
        chi tiêu tháng {tt.thang_hien} chưa có sẽ hiện ở <strong>📋 Việc của chủ nhà</strong>. Tạo bản tin mới có chép sẵn
        tên các khoản đến kỳ.
      </p>

      {tt.danh_muc.length === 0 ? (
        <p className="db-trong">Danh mục còn trống. Thêm vài khoản quen: tiền điện, tiền nước, học phí, bảo hiểm xe…</p>
      ) : (
        <ul className="kcd-ds">
          {tt.danh_muc.map((k) => (
            <li key={k.id} className={`kcd-dong ${k.dang_dung ? "" : "kcd-ngung"}`}>
              <span className="kcd-ten">
                <strong>{k.ten}</strong>
                {thieu.has(k.id) && <span className="kcd-thieu"> · tháng {tt.thang_hien} chưa có</span>}
                {!k.dang_dung && <span> · đang ngưng</span>}
              </span>
              <span className="mv-chip">{veKy(k)}</span>
              <span className="kcd-nut">
                {thieu.has(k.id) && (
                  <button
                    className="ct-nut-bao-lai"
                    disabled={dangLam}
                    onClick={() => lam(() => addData(`quan-tri/khoan-co-dinh/${k.id}/bo-qua`, {}), `Đã ghi: tháng ${tt.thang_hien} không có "${k.ten}"`)}
                  >
                    Tháng này không có
                  </button>
                )}
                <button
                  className="ct-nut-bao-lai"
                  disabled={dangLam}
                  onClick={() => lam(() => updateData("quan-tri/khoan-co-dinh", k.id, { ...k, dang_dung: !k.dang_dung }))}
                >
                  {k.dang_dung ? "Ngưng" : "Dùng lại"}
                </button>
                <button
                  className="btn-delete"
                  title="Xoá khỏi danh mục"
                  disabled={dangLam}
                  onClick={() => {
                    if (!hoiXoa("khoản cố định", k.ten, "Chỉ xoá khỏi danh mục — các bản tin chi tiêu đã đăng không bị đụng tới.")) return;
                    lam(() => deleteData("quan-tri/khoan-co-dinh", k.id));
                  }}
                >
                  🗑️
                </button>
              </span>
            </li>
          ))}
        </ul>
      )}

      <form className="kcd-form" onSubmit={them}>
        <input
          className="mv-o"
          value={form.ten}
          onChange={(e) => setForm((f) => ({ ...f, ten: e.target.value }))}
          placeholder="Tên khoản — Tiền nước…"
          maxLength={100}
        />
        <select className="mv-o" value={form.ky} onChange={(e) => setForm((f) => ({ ...f, ky: e.target.value }))}>
          <option value="thang">hằng tháng</option>
          <option value="quy">hằng quý</option>
          <option value="nam">hằng năm</option>
        </select>
        {form.ky !== "thang" && (
          <select
            className="mv-o"
            value={form.thang_den}
            onChange={(e) => setForm((f) => ({ ...f, thang_den: Number(e.target.value) }))}
            aria-label="Tháng đến kỳ"
          >
            {Array.from({ length: 12 }, (_, i) => i + 1).map((t) => (
              <option key={t} value={t}>từ tháng {t}</option>
            ))}
          </select>
        )}
        <button type="submit" className="nut nut-xanh mv-nut-to" disabled={dangLam}>Thêm</button>
      </form>
    </div>
  );
}

export default KhoanCoDinh;
